export const AI_ENHANCED_INSIGHT_DIMENSION: any = {
    id: "deckSize",
    requestParameterMap: {
        value: "deckSize",
    },
    type: "static_dropdown",
    configuration: {
        tooltip:
            "AI analyzes and prioritizes slides based on insight significance and potential impact to shorten the overall deck length.",
        items: [
            {
                value: "SHORT",
                label: "Short [25% deck length]",
            },
            {
                value: "MEDIUM",
                label: "Medium [50% deck length]",
            },
            {
                value: "FULL_LENGTH",
                label: "Full-Length [standard deck]",
            },
        ],
        label: "Deck length (AI Shortened)",
    },
    dependencies: [],
};
